<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>

	<form @submit.prevent="onSubmit">

		<smart-input :error="inputErrors.name" label='שם עיר' v-model="form.name"></smart-input>
		<div class="form-group">
			<v-btn type="submit" color="success">שמירה</v-btn>
		</div>
	</form>
</template>


<script>
	import CityModule from "src/store/modules/City.module";
	import FormView from "src/mixins/FormView";

	export default {
		props: [],
		name: "city-form",
		components: {},
		data() {
			return {
				form: {
					name: null,
				},
			};
		},
		mixins: [new FormView(CityModule,"city")],
		computed: {
			isNew(){
				return !!this.city.id;
			}
		}
	};
</script>

<style>

</style>
